import { useEffect, useState } from "react";

/** DS's `useDebouncedFn` debounces a callback; here we need a debounced
 *  value so text inputs update immediately while filtering waits. */
export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
  const [debounced, setDebounced] = useState<T>(value);
  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);
  return debounced;
};
